/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function ExternalMetadataGridViewController(this: JS5Object, uiGridConstants: JS5Object,
                                            $location: JS5Object, ExternalMetadataService: JS5Object,
                                            UtilsService: JS5Object, ModalService: JS5Object) {
    const gridColumns = [
        {
            field: 'enabled',
            displayName: 'Enabled',
            cellTemplate: 'components/visual/grid/radio-button-template.html',
            width: 70
        },
        {
            field: 'name',
            displayName: 'External Source Name',
            sort: {
                direction: uiGridConstants.ASC,
                priority: 1
            },
            cellTemplate: 'components/visual/grid/base-tooltip-template.html',
            width: 300
        },
        {
            field: 'type',
            sort: {
                direction: uiGridConstants.ASC,
                priority: 0
            },
            displayName: 'Type',
            cellTemplate: 'components/visual/grid/base-tooltip-template.html',
            width: 200
        },
        {
            field: 'sourceLocation',
            displayName: 'Source Location',
            cellTemplate: 'components/visual/grid/base-tooltip-template.html'
        },
        {
            field: 'xslTemplate.name',
            displayName: 'Template Name',
            cellTemplate: 'components/visual/grid/base-tooltip-template.html',
            width: 400
        },
        {
            field: 'minimumReleaseDate',
            displayName: 'Minimum Release Date',
            cellTemplate: 'components/visual/grid/base-tooltip-template.html',
            cellFilter: 'amDateFormat: \'MMMM DD, YYYY\'',
            width: 200
        }
    ];

    let getData = (): void => {
        this.loadingIndicator.show = true;
        ExternalMetadataService.getExternalSources().then((data: JS5Object): void => {
            embellishGridDataItems(data);
            this.gridOptions.data = data;
            this.loadingIndicator.show = false;
        });
    };

    const embellishGridDataItems = (data: JS5Object) => {
        _.forEach(data, (entity) => {
            let ingestType = ExternalMetadataService.getExternalSourceType(entity);
            entity.type = ingestType.displayName;

            if (ingestType === UtilsService.externalIngestTypes.watchFolder) {
                entity.sourceLocation = entity.watchFolderPath;
            }
            else {
                entity.sourceLocation = entity.feedUrl;
            }
        });
    };

    let editExternalSystem = (entity: JS5Object) => {
        $location.url(`/system/aggregation/edit/${entity.id}/${ExternalMetadataService.getExternalSourceType(entity).value}`);
    };

    this.loadingIndicator = {
        backdrop: true,
        show: false,
        title: 'Working',
        message: 'Please wait...'
    };

    this.onRowDblClick = function (row: JS5Object) {
        editExternalSystem(row.entity);
    };

    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: gridColumns,
        onRegisterApi: (gridApi: JS5Object) => {
            this.gridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        data: []
    };
    const onSelectExternalIngestType = (selectedType: JS5Object) => {
        $location.url(`/system/aggregation/edit/-1/${selectedType}`);
    };

    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: () => true,
            onClick: (): void => {
                ModalService.showExternalIngestTypeModal(onSelectExternalIngestType);
            }
        },
        {
            label: 'Edit',
            enabled: () => _.size(this.gridApi.selection.getSelectedRows()),
            onClick: (): void => {
                editExternalSystem(_.first(this.gridApi.selection.getSelectedRows()));
            }
        },
        {
            icon: 'fa-upload',
            label: 'Run',
            enabled: () => _.size(this.gridApi.selection.getSelectedRows()),
            onClick: (): void => {
                ModalService.showExternalIngestRunModal(_.first(this.gridApi.selection.getSelectedRows()).id);
            }
        }
    ];

    this.$onInit = (): void => {
        getData();
    };
}

angular.module('prism-ui.externalMetadata').component('externalMetadataGridView', {
    controller: ExternalMetadataGridViewController,
    templateUrl: 'system/externalMetadata/setup/gridView/external-metadata-grid-view-template.html'
});
